const version = require('element-ui/package.json').version
const ORIGINAL_THEME_COLOR = '#409EFF'

const themeUtils = {
  chalk: '',
  changeTheme: function (themeColor, originalColor) {
    if (typeof themeColor !== 'string') {
      return false
    }
    if (!originalColor) {
      originalColor = ORIGINAL_THEME_COLOR
    }
    const themeCluster = this.getThemeCluster(themeColor.replace('#', ''))
    const originalCluster = this.getThemeCluster(originalColor.replace('#', ''))
    const getHandler = (variable, id) => {
      return () => {
        const originalCluster = this.getThemeCluster(ORIGINAL_THEME_COLOR.replace('#', ''))
        const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster)
        const anchorId = id + '-anchor'
        let anchor = document.getElementById(anchorId)

        // 删除旧的 style 标签
        const oldStyleTag = document.getElementById(id)
        if (oldStyleTag) {
          oldStyleTag.parentNode.removeChild(oldStyleTag)
        }

        // 创建新的 style 标签
        const styleTag = document.createElement('style')
        styleTag.setAttribute('id', id)
        styleTag.innerText = newStyle

        if (!anchor) {
          // 第一次插入：创建锚点，将 style 插入到所有 style 标签最前面
          anchor = document.createElement('meta')
          anchor.setAttribute('id', anchorId)
          const allStyles = document.head.getElementsByTagName('style')
          if (allStyles.length > 0) {
            document.head.insertBefore(styleTag, allStyles[0])
          } else {
            document.head.insertBefore(styleTag, document.head.firstChild)
          }
          // 锚点放在 style 之后，便于后续更新时定位
          document.head.insertBefore(anchor, styleTag.nextSibling)
        } else {
          // 后续更新：在锚点前插入
          document.head.insertBefore(styleTag, anchor)
        }
      }
    }
    const chalkHandler = getHandler('chalk', 'chalk-style')
    if (!this.chalk) {
      const url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`
      this.getCSSString(url, chalkHandler, 'chalk')
    } else {
      chalkHandler()
    }
    const styles = [].slice.call(document.querySelectorAll('style'))
      .filter(style => {
        const text = style.innerText
        return new RegExp(originalColor, 'i').test(text) && !/Chalk Variables/.test(text)
      })
    styles.forEach(style => {
      const { innerText } = style
      if (typeof innerText !== 'string') return
      style.innerText = this.updateStyle(innerText, originalCluster, themeCluster)
    })
    return true
  },
  updateStyle (style, oldCluster, newCluster) {
    let newStyle = style
    oldCluster.forEach((color, index) => {
      newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index])
    })
    return newStyle
  },
  getCSSString (url, callback, variable) {
    const xhr = new XMLHttpRequest()
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '')
        callback()
      }
    }
    xhr.open('GET', url)
    xhr.send()
  },
  getThemeCluster (theme) {
    const tintColor = (color, tint) => {
      let red = parseInt(color.slice(0, 2), 16)
      let green = parseInt(color.slice(2, 4), 16)
      let blue = parseInt(color.slice(4, 6), 16)
      if (tint === 0) { // when primary color is in its rgb space
        return [red, green, blue].join(',')
      } else {
        red += Math.round(tint * (255 - red))
        green += Math.round(tint * (255 - green))
        blue += Math.round(tint * (255 - blue))
        red = red.toString(16)
        green = green.toString(16)
        blue = blue.toString(16)
        return `#${red}${green}${blue}`
      }
    }
    const shadeColor = (color, shade) => {
      let red = parseInt(color.slice(0, 2), 16)
      let green = parseInt(color.slice(2, 4), 16)
      let blue = parseInt(color.slice(4, 6), 16)
      red = Math.round((1 - shade) * red)
      green = Math.round((1 - shade) * green)
      blue = Math.round((1 - shade) * blue)
      red = red.toString(16)
      green = green.toString(16)
      blue = blue.toString(16)
      return `#${red}${green}${blue}`
    }
    const clusters = [theme]
    for (let i = 0; i <= 9; i++) {
      clusters.push(tintColor(theme, Number((i / 10).toFixed(2))))
    }
    clusters.push(shadeColor(theme, 0.1))
    return clusters
  }
}

export default themeUtils
